import PageCommon from "./PageCommon.js";
import Pqp from "../3x1010/Pqp.js";
import { ModalAlert } from "../su/Modals.js";
import Globals from "../Globals.js";


export default class PageJob extends PageCommon {
  constructor() {
    super();
    PageJob.that = this;
  }
  init($data) {
    super.init($data);
    this.showPreloader(false);
    Pqp.trace("PageJob - Hello world");

    $(".btn-close", ".js-modal-form-success").on("click", (e) => {
      $(".js-modal-form-success").fadeOut();
    });
    $(".btn-close", ".js-modal-form-error-email").on("click", (e) => {
      $(".js-modal-form-error-email").fadeOut();
    });
    $(".btn-close", ".js-modal-error-generic").on("click", (e) => {
      $(".js-modal-error-generic").fadeOut();
    });
    $(".btn-close-modal").on("click", (e) => {
      $(".js-modal-form-error-email").fadeOut();
      $(".js-modal-error-generic").fadeOut();
      $(".js-modal-form-success").fadeOut();
    });

    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    var forms = document.querySelectorAll('.needs-validation')
    // Loop over them and prevent submission
    Array.prototype.slice.call(forms).forEach(function (form) {
      form.addEventListener(
        'submit',
        function (event) {

          PageJob.that.checkMandatoryUploads()

          if (!form.checkValidity()) {
            event.preventDefault()
            event.stopPropagation()
          }

          form.classList.add('was-validated')

          if (form.checkValidity()) {
            console.log('submit ok')
            event.preventDefault()
            event.stopPropagation()

            let uidJob = $.trim($("#uidJob").val());
            let name = $.trim($("#name").val());
            let surname = $.trim($("#surname").val());
            let email = $.trim($("#email").val());
            let phone = $.trim($("#phone").val());
            let linkedin = $.trim($("#linkedin").val());
            let uploadCoverLetter = $("#coverletterUpload_content").attr('src');
            let uploadCV = $("#cvUpload_content").attr('src');

            const inquiries = [];
            $('.js-inquiry').each(function () {
              let inquiry = {
                "Uid": $(this).attr('data-item-uid'),
                "Response": $(this).val()
              }
              inquiries.push(inquiry);
            });

            let rq = {
              ContentLocale: TheApp.Locale,
              Data: {
                UidJob: uidJob,
                FirstName: name,
                LastName: surname,
                Email: email,
                Phone: phone,
                LinkedinUrl: linkedin,
                UploadCV: uploadCV,
                UploadCoverLetter: uploadCoverLetter,
                Inquiries: inquiries
              }
            }
            console.log(rq);
            $(".js-form-preloader").fadeIn();
            self = this;
            thatServiceManeger.standardCall("/api/app/createApplication", rq, function (rs) {
              $(".js-form-preloader").fadeOut();
              if (rs && rs.Success === true) {
                $(".js-modal-form-success").fadeIn();
                $(".btn-main", "form").css({ "pointer-events": "none", "opacity": ".5" });
                return;
              }
              else {
                if (rs && rs.StatusCode && rs.StatusCode === 409) {
                  $(".js-modal-form-error-email").fadeIn();
                  return;
                }
                else {
                  $(".js-modal-error-generic").fadeIn();
                  return;
                }
              }
            });
          }
          return false;
        },
        false
      )
    })

    this.clUpload = this.initUpload('coverletterUpload');
    this.cvUpload = this.initUpload('cvUpload');

    // dispaccio un evento globale
    try {
      this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);
    } catch (error) {
      console.log(error);
    }
  }

  initUpload(id) {
    var para = new TrixUloaderParams();
    para.UplElementTriggerId = id;
    para.UplMaxFileSize = "2"; // 10 MB
    para.UplMaxNumFile = 1; // <0 infinite
    para.UplElementDragId = id;
    para.UplDragEnabled = true;
    para.UplFilterTitle = "Doc";
    para.UplFilterExtensions = "doc,docx,txt,pdf";
    para.UplFilterMimeTypes = "application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf";
    para.UplNaming = "/jobapplication/{GUID}.{NEXT}";
    para.UplImageResample = "";
    para.UplRepositoryFolder = "/data/public/";
    //
    var uplObject = new TrixUloaderObject(para);
    uplObject.init(jQuery.proxy(this.uploadHandler,/* this*/ null, id));
    return uplObject;
  }

  uploadHandler(id, ev) {
    if (ev.type == "start") {
      //this.setUiError(null);
      //CMS.Common.showLoading(true, "0%");
      //page.showPreloader(true);
      $(".js-upload-file-" + id).removeClass("has-error");
      $("#" + id + "_content").text("");
      $(".js-file-img-" + id).hide();
      $(".js-form-preloader").fadeIn();
    }
    else if (ev.type == "progress") {
      // CMS.Common.showLoading(true, (ev.data.TotalPercent) + "%");
    }
    else if (ev.type == "error") {
      //this.setUiError(ev.data);
      page.showPreloader(false);
      $("#" + id + "_content").text("Errore " + ev.data.Mex);
      $(".js-upload-file-" + id).addClass("has-error");
      $(".js-file-img-" + id).hide();
      $("#" + id).text(TheApp.Res[TheApp.Locale]["ERROR.UploadMessage"]);
      $(".js-form-preloader").fadeOut();
    }
    else if (ev.type == "complete") {
      page.showPreloader(false);
      // this.setValue(ev.data.Files[0].Url);            
      $("#" + id).text(ev.data.Files[0].OriFileName);
      //$("#" + id + "_content").text(ev.data.Files[0].Url);
      $("#" + id + "_content").attr("src", ev.data.Files[0].Url);
      $("#" + id + "_content").attr("style", "");
      $(".js-file-img-" + id).show();
      $(".js-form-preloader").fadeOut();
    }
  }
  get isHomepage() {
    return false;
  }

  getUpload(upload) {
    if (upload.response) {
      return upload.response.Files[0].OriFileName;
    }
    return ""
  }


  checkMandatoryUploads() {
    //debugger
    const atLeastOne = jQuery("form").data("form-atleastonerequired");
    const cvMandatory = jQuery("form").data("form-uplcv-required");
    const letterMandatory = jQuery("form").data("form-uplcoverletter-required");

    //const cv = jQuery.trim(jQuery("#cvmFile").val())
    //const letter = jQuery.trim(jQuery("#clmFile").val());
    const cv = this.getUpload(this.cvUpload);
    const letter = this.getUpload(this.clUpload);

    const linkedin = jQuery.trim(jQuery("#linkedin").val());

    //jQuery("#cvmFile").get(0).setCustomValidity("");
    //jQuery("#clmFile").get(0).setCustomValidity("");
    //jQuery("#cvmFile").removeClass("is-wrong")
    //jQuery("#clmFile").removeClass("is-wrong")
    //jQuery("#cvmFile").addClass("is-correct")
    //jQuery("#clmFile").addClass("is-correct")

    $("#coverletterUpload").closest(".js-upload-file-coverletterUpload").removeClass("is-wrong");
    $("#coverletterUpload").closest(".js-upload-file-coverletterUpload").addClass("is-correct");
    $("#cvUpload").closest(".js-upload-file-cvUpload").removeClass("is-wrong");
    $("#cvUpload").closest(".js-upload-file-cvUpload").addClass("is-correct");

    jQuery("#linkedin").get(0).setCustomValidity("");
    jQuery(".js-docs").hide();

    // Controlli formali sui dati se inseriti
    if (linkedin !== "") {
      if (!this.isValidHttpUrl(linkedin)) {
        jQuery("#linkedin").get(0).setCustomValidity(TheApp.Res[TheApp.Locale]["ERROR.LinkedinBadUrl"]);
      }
    }

    if (atLeastOne) {
      if (cv === "" && letter === "" && linkedin === "") {
        //jQuery("#cvmFile").get(0).setCustomValidity(TheApp.Res[TheApp.Locale]["ERROR.AtLeastOneRequired"]);
        //jQuery("#clmFile").get(0).setCustomValidity(TheApp.Res[TheApp.Locale]["ERROR.AtLeastOneRequired"]);
        //jQuery("#cvmFile").removeClass("is-wrong")
        //jQuery("#clmFile").removeClass("is-wrong")
        //jQuery("#cvmFile").addClass("is-wrong")
        //jQuery("#clmFile").addClass("is-wrong")
        $("#coverletterUpload").closest(".js-upload-file-coverletterUpload").removeClass("is-wrong");
        $("#coverletterUpload").closest(".js-upload-file-coverletterUpload").addClass("is-wrong");
        $("#cvUpload").closest(".js-upload-file-cvUpload").removeClass("is-wrong");
        $("#cvUpload").closest(".js-upload-file-cvUpload").addClass("is-wrong");
        jQuery("#linkedin").get(0).setCustomValidity(TheApp.Res[TheApp.Locale]["ERROR.AtLeastOneRequired"]);
        jQuery(".js-docs").show();
      }
    } else {
      if (cvMandatory && cv === "") {
        //jQuery("#cvmFile").get(0).setCustomValidity(TheApp.Res[TheApp.Locale]["ERROR.CVRequired"]);
        //jQuery("#cvmFile").removeClass("is-wrong")
        //jQuery("#cvmFile").addClass("is-wrong")
        $("#cvUpload").closest(".js-upload-file-cvUpload").removeClass("is-wrong");
        $("#cvUpload").closest(".js-upload-file-cvUpload").addClass("is-wrong");
      }
      if (letterMandatory && letter === "") {
        //jQuery("#clmFile").get(0).setCustomValidity(TheApp.Res[TheApp.Locale]["ERROR.CLRequired"]);
        //jQuery("#clmFile").removeClass("is-wrong")
        //jQuery("#clmFile").addClass("is-wrong")
        $("#coverletterUpload").closest(".js-upload-file-coverletterUpload").removeClass("is-wrong");
        $("#coverletterUpload").closest(".js-upload-file-coverletterUpload").addClass("is-wrong");
      }
    }
  }

  isValidHttpUrl(string) {
    let url;
    try {
      url = new URL(string);
    } catch (_) {
      return false;
    }
    return url.protocol === "http:" || url.protocol === "https:";
  }

}

